import "./topbar.scss"
import GitHubIcon from '@mui/icons-material/GitHub';
import MailIcon from '@mui/icons-material/Mail';

export default function Topbar({menueOpen, setMenueOpen, theme, setTheme}) {
  return (
    <div className={"topbar " + ((menueOpen && "active ") || (theme && "dark"))}>
        <div className="wrapper"  id="topbar"> 
            <div className="left">
                <a href="#intro"  className="logo"> Ananya.</a>
                <div className="itemContainer">
                    <GitHubIcon className="icon"/>
                    <span className="span"> <a href="https://github.com/ananyajain10"> ananyajain10 </a></span>
                    </div>
                    <div className="itemContainer">
                    <MailIcon className="icon"/>
                    <span className="span">jainananya355@jmail.com</span>
                </div>
            </div>
           
            <div className="right" >
                <div className={"slider"}>
                    <div className="slider-bar">
                        <div className="slider-circle" onClick={() => setTheme(!theme)}></div>
                    </div>
                </div>
                <div className="hamburger" onClick={() => setMenueOpen (!menueOpen)}>
                    <span className="Line1"></span>
                    <span className="Line2"></span>
                    <span className="Line3"></span>
                </div>

            </div>
        </div>
       
    </div>
    
  )
}
